export default "__VITE_ASSET__D1OzI5z4__"